import styled, { css } from 'styled-components';

export const PriceChangesChartRoot = styled.div`
  position: relative;
  overflow: visible;
`;

export const PriceChangesChartContainer = styled.div`
  overflow: visible;
`;

export const Plot = styled.svg`
  position: relative;
  width: 100%;
  height: 340px;
  overflow: visible;
`;

export const CanvasOverlay = styled.canvas<{
  $marginTop: number;
  $marginLeft: number;
}>`
  position: absolute;
  top: ${({ $marginTop }) => $marginTop}px;
  left: ${({ $marginLeft }) => $marginLeft}px;
  pointer-events: none;
`;

export const VerticalLine = styled.line<{ $isDashed?: boolean }>`
  stroke: var(--border-default);
  stroke-width: 2px;

  ${props =>
    props.$isDashed &&
    css`
      stroke-dasharray: 4 4;
    `};
`;

export const TooltipLine = styled.line`
  stroke: var(--border-default);
  stroke-dasharray: 4 4;
`;
